// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePlpApi = class EdgePlpApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param scriptsPlpAccountRegisterAccount default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async accountRegister(scriptsPlpAccountRegisterAccount, xProgramId) {
        const _url_ = '/edge/plp/Account/register';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'scriptsPlpAccountRegisterAccount' is not null or undefined
        if (scriptsPlpAccountRegisterAccount === null || scriptsPlpAccountRegisterAccount === undefined) {
            throw new Error('Required parameter scriptsPlpAccountRegisterAccount was null or undefined when calling accountRegister.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(scriptsPlpAccountRegisterAccount, "ScriptsPlpAccountRegisterAccount"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpAccountRegisterRegisterResponse");
        }
        return response;
    }
    /**
     *
     * @param scriptsPlpClaimSumbitClaimRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async claimSubmitClaim(scriptsPlpClaimSumbitClaimRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Claim/submitClaim';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'scriptsPlpClaimSumbitClaimRequestModel' is not null or undefined
        if (scriptsPlpClaimSumbitClaimRequestModel === null || scriptsPlpClaimSumbitClaimRequestModel === undefined) {
            throw new Error('Required parameter scriptsPlpClaimSumbitClaimRequestModel was null or undefined when calling claimSubmitClaim.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(scriptsPlpClaimSumbitClaimRequestModel, "ScriptsPlpClaimSumbitClaimRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SubmitClaimResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param hybridEnrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollPatientEnrollPatient(hybridEnrollmentRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Enrollment/enrollPatient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'hybridEnrollmentRequestModel' is not null or undefined
        if (hybridEnrollmentRequestModel === null || hybridEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter hybridEnrollmentRequestModel was null or undefined when calling enrollPatientEnrollPatient.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(hybridEnrollmentRequestModel, "HybridEnrollmentRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param medBenEnrollmentUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async enrollPatientEnrollmentUpdate(medBenEnrollmentUpdateRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Enrollment/enrollmentUpdate';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'medBenEnrollmentUpdateRequestModel' is not null or undefined
        if (medBenEnrollmentUpdateRequestModel === null || medBenEnrollmentUpdateRequestModel === undefined) {
            throw new Error('Required parameter medBenEnrollmentUpdateRequestModel was null or undefined when calling enrollPatientEnrollmentUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(medBenEnrollmentUpdateRequestModel, "MedBenEnrollmentUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "HybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientGetEnrollments(xProgramId) {
        const _url_ = '/edge/plp/Patient/getEnrollments';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpPatientGetEnrollmentsGetEnrollmentsResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentPatientLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientPatientLookup(enrollmentPatientLookupRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Patient/patientLookup';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentPatientLookupRequestModel' is not null or undefined
        if (enrollmentPatientLookupRequestModel === null || enrollmentPatientLookupRequestModel === undefined) {
            throw new Error('Required parameter enrollmentPatientLookupRequestModel was null or undefined when calling patientPatientLookup.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentPatientLookupRequestModel, "EnrollmentPatientLookupRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpPatientPatientLookupPatientLookupResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentPatientUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async patientUpdate(enrollmentPatientUpdateRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Patient/update';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentPatientUpdateRequestModel' is not null or undefined
        if (enrollmentPatientUpdateRequestModel === null || enrollmentPatientUpdateRequestModel === undefined) {
            throw new Error('Required parameter enrollmentPatientUpdateRequestModel was null or undefined when calling patientUpdate.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentPatientUpdateRequestModel, "EnrollmentPatientUpdateRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponseModel");
        }
        return response;
    }
    /**
     *
     * @param enrollmentCreatePrescriberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async prescriberCreatePrescriber(enrollmentCreatePrescriberRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Prescriber/createPrescriber';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentCreatePrescriberRequestModel' is not null or undefined
        if (enrollmentCreatePrescriberRequestModel === null || enrollmentCreatePrescriberRequestModel === undefined) {
            throw new Error('Required parameter enrollmentCreatePrescriberRequestModel was null or undefined when calling prescriberCreatePrescriber.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentCreatePrescriberRequestModel, "EnrollmentCreatePrescriberRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentCreatePrescriberResultModelResponse");
        }
        return response;
    }
    /**
     *
     * @param enrollmentCreateSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async siteCreateSite(enrollmentCreateSiteRequestModel, xProgramId) {
        const _url_ = '/edge/plp/Site/createSite';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'enrollmentCreateSiteRequestModel' is not null or undefined
        if (enrollmentCreateSiteRequestModel === null || enrollmentCreateSiteRequestModel === undefined) {
            throw new Error('Required parameter enrollmentCreateSiteRequestModel was null or undefined when calling siteCreateSite.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(enrollmentCreateSiteRequestModel, "EnrollmentCreateSiteRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentCreateSiteResultModelResponse");
        }
        return response;
    }
};
EdgePlpApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePlpApi);
export { EdgePlpApi };
//# sourceMappingURL=edgePlpApi.js.map